import '../App.css';
import "leaflet/dist/leaflet.css";

import {MapContainer, Marker, TileLayer, Tooltip} from "react-leaflet";
import L from 'leaflet';
import {Icon} from "leaflet";
import React from "react";
import {Typography} from "@mui/material";
import MarkerClusterGroup from "react-leaflet-cluster";


const customIcon = new Icon({
    iconUrl: require("../assets/icon/pin.png"),
    // iconUrl: require("../assets/icon/pin.svg").default,
    iconSize: [38, 38]
});

const WORLD_BOUNDS = L.latLngBounds([[-90, -180], [90, 180]]);

function getLocation(unit) {
    return [parseFloat(unit.u_latitude), parseFloat(unit.u_longitude)]
}


const createClusterCustomIcon = function (cluster) {
    return L.divIcon({
        html: `<span>${cluster.getChildCount()}</span>`,
        className: "custom-marker-cluster",
        iconSize: L.point(40, 40, true),
    });
};

export function PositionMap({units, className, handleClick, setMapView}) {
    const filteredUnits = Array.isArray(units) ? units.filter((unit) => (unit.u_latitude && unit.u_longitude)) : [];

    if (filteredUnits.length === 0) {
        sessionStorage.setItem('mapView', 'F');
        setMapView(false);
        return;
    }

    return (
        <MapContainer
            className={className || "leaflet-container"}
            center={getLocation(filteredUnits[0])}
            zoom={className === "leaflet-container-mini" ? 13 : 4}
            minZoom={3}
            maxBounds={WORLD_BOUNDS}
            maxBoundsViscosity={1.0}
            scrollWheelZoom
            attributionControl={false}
            sx={{width: '100%', height: '100%'}}
        >
            <TileLayer
                noWrap={true}
                // bounds={WORLD_BOUNDS}
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            />
            <MarkerClusterGroup
                // UX
                iconCreateFunction={createClusterCustomIcon}
                showCoverageOnHover={false}
                zoomToBoundsOnClick
                maxClusterRadius={10}
                spiderfyOnEveryZoom
                spiderfyOnMaxZoom
                // Perf
                chunkedLoading
            >
                {filteredUnits.map((unit) => (
                    <Marker position={getLocation(unit)}
                            icon={customIcon}
                            eventHandlers={{click: handleClick ? () => handleClick(unit) : () => null}}
                            key={`marker_${unit.u_sn}`}
                    >
                        <Tooltip>
                            <Typography variant='body2'>Unit {unit.u_sn}</Typography>
                            Wifi Status: {unit.u_wifi ? 'Online' : 'Offline'}
                            <br/>
                            Unit Status: {unit.u_status}
                            <br/>
                            {unit.u_status === 'Connected' && `Camera Status: ${unit.u_cam_issue ? 'Camera Malfunction' : 'All Camera Functional'}`}
                        </Tooltip>
                    </Marker>
                ))}
            </MarkerClusterGroup>
        </MapContainer>
    )
}